/* eslint-disable react/jsx-no-duplicate-props */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Fab, TextField, Switch, MenuItem } from '@mui/material';
import toast from 'react-hot-toast';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import _ from 'lodash';
import * as Yup from 'yup';
import { ReactFormBuilder, ReactFormGenerator } from 'react-form-builder2';
import 'react-form-builder2/dist/app.css';
import './DynamicForm.css';

import { createSafalEventDynamicForm } from '../../../../services/Service';
import { transformYupErrorsIntoArray } from '../../../../utils/fn';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '800px',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  maxHeight: '95vh',
  overflow: 'auto',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  '@media (max-width: 640px)': {
    width: '95vw',
    height: '95vh',
    overflow: 'auto',
  },
};

export default function DynamicFormViewModal({ data, open, onClose }) {
  const [builderData, setBuilderData] = React.useState([]);
  const [isDisableAll, setIsDisableAll] = React.useState(false);

  const onCloseThis = (refetchFlag, resData) => {
    setIsDisableAll(false);
    setBuilderData([]);
    onClose(refetchFlag, resData);
  };

  const handleClose = async (refetchFlag, directClose, resData) => {
    onCloseThis(refetchFlag, resData);
  };

  const onSubmit = async () => {
    setIsDisableAll(true);
    try {
      const payload = {
        element: builderData,
      };

      // const res = await createSafalEventDynamicForm(payload);
      // if (res.status === 200) {
      //   toast.success(res.data.message);
      //   handleClose(true, true, res.data?.data);
      // }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const _data = data || [];

  return (
    <>
      <Modal sx={{ zIndex: 345 }} open={open} onClose={handleClose}>
        <Box sx={style}>
          <Fab
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
            onClick={handleClose}
            size="small"
            color="primary"
            aria-label="add"
          >
            <CloseIcon />
          </Fab>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ fontSize: '24px', fontWeight: 700, color: '#3D71FF' }}>
              Invite Dynamic Form Preview
            </Typography>
          </div>
          <div id="DynamicFormDiv">
            <ReactFormGenerator
              data={_data}
              onSubmit={(values) => {
                setBuilderData(values);
                console.log('DEBUG ReactFormBuilder onSubmit', values);
              }}
              submitButton={
                <Button
                  type="submit"
                  disabled={isDisableAll}
                  sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                  variant="contained"
                >
                  Submit
                </Button>
              }
            />
          </div>
          {/* <div
            style={{
              display: 'flex',
              gap: '12px',
              marginTop: '22px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div />
            <div style={{ display: 'flex', gap: '12px', marginTop: '22px', alignItems: 'center' }}>
              <Button
                disabled={isDisableAll}
                sx={{
                  backgroundColor: '#ff4842',
                  ':hover': { backgroundColor: '#d40700' },
                  color: 'white',
                  borderRadius: '30px',
                  textTransform: 'capitalize',
                }}
                onClick={handleClose}
                variant="contained"
              >
                Close
              </Button>
              {!isDisplay && data === null && (
                <Button
                  disabled={isDisableAll}
                  onClick={onSubmit}
                  sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                  variant="contained"
                >
                  Create
                </Button>
              )}
            </div>
          </div> */}
        </Box>
      </Modal>
    </>
  );
}
